import { render, staticRenderFns } from "./OnboardingStep03.vue?vue&type=template&id=2ad7b698&scoped=true&"
import script from "./OnboardingStep03.vue?vue&type=script&lang=js&"
export * from "./OnboardingStep03.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStep03.vue?vue&type=style&index=0&id=2ad7b698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad7b698",
  null
  
)

export default component.exports